const constProperty = (target, constName, constValue, { enumerable } = { enumerable: false }) => {
  Object.defineProperty(target, constName, {
    value: constValue,
    enumerable: enumerable,
    writable: false
  })
}

export default constProperty
